var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import 'setimmediate';
import DataLoader from 'dataloader';
export class EventerApiClient {
    constructor(apiBaseUrl = 'https://api.eventer.app/v1/') {
        /**
         * Caches places by googlePlaceId
         * see: https://github.com/graphql/dataloader
         */
        this.placeLoader = new DataLoader((googlePlaceIds) => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.post('places', { body: { google_place_ids: googlePlaceIds } });
            return googlePlaceIds.map((googlePlaceId) => {
                return response.places[googlePlaceId];
            });
        }));
        this.apiBaseUrl = apiBaseUrl;
    }
    /** see: https://apidoc.eventer.app/#operation/discover-places-post */
    searchEvents(request) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.post('events', {
                body: request,
            });
        });
    }
    /** see: https://apidoc.eventer.app/#operation/get-place-by-id */
    getPlace(googlePlaceId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.placeLoader.load(googlePlaceId);
        });
    }
    /** see: https://apidoc.eventer.app/#operation/discover-places-post */
    getPlaces(googlePlaceIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.placeLoader.loadMany(googlePlaceIds);
        });
    }
    post(path, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            };
            const response = yield fetch(`${this.apiBaseUrl}${path}`, {
                method: 'POST',
                headers,
                body: options ? JSON.stringify(options.body) : '',
            });
            if (!response.ok) {
                const errorMessage = yield response.text();
                throw new Error(errorMessage);
            }
            return yield response.json();
        });
    }
}
